import axios from 'axios';

/** Prefer API error body text (e.g. Fiserv resptext) over a generic Axios message. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
	if (axios.isAxiosError(error)) {
		const data = error.response?.data;
		if (typeof data === 'string' && data.trim()) return data.trim();
		if (data && typeof data === 'object') {
			const record = data as Record<string, unknown>;
			if (typeof record.message === 'string' && record.message.trim()) return record.message.trim();
			if (typeof record.title === 'string' && record.title.trim()) return record.title.trim();
			if (typeof record.error === 'string' && record.error.trim()) return record.error.trim();
		}
		if (error.message && !error.message.startsWith('Request failed with status code')) {
			return error.message;
		}
	}
	if (error instanceof Error && error.message) return error.message;
	return fallback;
}
